import { PermissionsContext } from "@/routes/dashboard/-permissions";
import { useContext } from "react";

export const usePermissions = () => {
  const ctx = useContext(PermissionsContext);
  if (!ctx) throw new Error("PermissionsContext not found");
  return {
    permissions: ctx.permissions,
    overrideState: [ctx.override, ctx.setOverride] as const,
    roleState: [ctx.selectedRole, ctx.setSelectedRole] as const,
  };
};
